import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "utils/AuthContext";
import { loadTrialStore, setOnboardingFlag } from "utils/TrialStore";
import Button from "components/Button";

import xmark from "imgs/xmark.png";

// One-shot onboarding nudge shown when a brand-new visitor lands in trial
// mode. Points at the "+" button above the names column. The user can either
// add a single teammate (which opens the existing AddPersonPopup) or seed a
// small sample team to play with.
export default function WelcomePopup({ onAddTeammate, onAddedSampleTeam }) {
  const { addTrialSampleTeam } = useContext(AuthContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const state = loadTrialStore();
    if (state && !state.onboarding?.welcomeDismissed) setVisible(true);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    const state = loadTrialStore();
    if (state) setOnboardingFlag(state, "welcomeDismissed", true);
    setVisible(false);
  };

  const handleAddTeammate = () => {
    dismiss();
    if (onAddTeammate) onAddTeammate();
  };

  const handleSampleTeam = () => {
    if (addTrialSampleTeam) addTrialSampleTeam();
    setVisible(false);
    if (onAddedSampleTeam) onAddedSampleTeam();
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 230,
        left: 20,
        zIndex: 5000,
        maxWidth: 320,
        background: "#fff",
        color: "#000",
        borderRadius: 8,
        padding: 18,
        boxShadow: "0 6px 24px rgba(0,0,0,0.15)",
        border: "1px solid #ccc",
      }}
    >
      <img
        alt="close"
        src={xmark}
        onClick={dismiss}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          height: 10,
          filter: "invert(0.4)",
          cursor: "pointer",
        }}
      />
      <div style={{ fontSize: 26, fontWeight: "bold", marginBottom: 8, lineHeight: 1.1 }}>Welcome.</div>
      <div style={{ fontSize: 13, lineHeight: 1.4, opacity: 0.85, marginBottom: 14 }}>
        We're not going to pitch you. Just try the tool. If you like it, then register.
      </div>
      <div style={{ fontSize: 13, opacity: 0.6, marginBottom: 6 }}>
        Click the + above your name to add teammates...
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 10 }}>
        <Button text="Add a teammate" callback={handleAddTeammate} color="#27ae60" />
        <Button text="...or load a sample team" callback={handleSampleTeam} lightmode />
      </div>
      {/* Arrow pointing up-left toward the names column's + button */}
      <div
        style={{
          position: "absolute",
          top: -9,
          left: 20,
          width: 0,
          height: 0,
          borderLeft: "8px solid transparent",
          borderRight: "8px solid transparent",
          borderBottom: "8px solid #ccc",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: -8,
          left: 20,
          width: 0,
          height: 0,
          borderLeft: "8px solid transparent",
          borderRight: "8px solid transparent",
          borderBottom: "8px solid #fff",
        }}
      />
    </div>
  );
}
